// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"605f6759","526":"cbe92dbe"}[chunkId] + ".chunk.js";
};